export default __webpack_public_path__ + "static/media/israel-bidur-black.82cba71f.svg";